// NOTE: Filenames currently include mixed case and spaces.
// We will normalize to lowercase_with_underscores in a follow-up asset pass.
export const PROFILE_CHARACTERS = [
  "/profile/character/durrr.PNG",
  "/profile/character/hmmm.PNG",
  "/profile/character/scheme.PNG",
] as const;

export const PROFILE_BACKGROUNDS = [
  "/profile/backgrounds/blue.PNG",
  "/profile/backgrounds/blue text.PNG",
  "/profile/backgrounds/green.PNG",
  "/profile/backgrounds/yellow.PNG",
  "/profile/backgrounds/yellow dull text.PNG",
] as const;

export const DEFAULT_PROFILE_CHARACTER = PROFILE_CHARACTERS[0];
export const DEFAULT_PROFILE_BACKGROUND = PROFILE_BACKGROUNDS[0];

export type ProfileCharacter = (typeof PROFILE_CHARACTERS)[number];
export type ProfileBackground = (typeof PROFILE_BACKGROUNDS)[number];
